import { EtiquetasGenerales_ES } from './Genericos/EtiquetasGenerales_ES';

const EtiquetasModulo = {
    NombrePortal: {
        Et_Nombre: "Portal Nuevo Ingreso"
    },
    Home: {
        Et_lblHola: 'Hola',
        Et_lblSaludosDia: 'Bienvenido al Portal Nuevo Ingreso',
        Et_lblDescripcion: 'Que tus metas no se detengan, empieza tu proyecto académico y haz que tus sueños se cumplan.',
        Et_lblRegistro: 'Registro',
        Et_lblAdmision: 'Admisión',
        Et_lblDatosPersonales: 'Datos personales',
        Et_lblContactos: 'Contactos',
        Et_lblSeleccion: 'Selección',
        Et_lblRequisitosAdmision: 'Requisitos de admisión',
        Et_lblCodigoVerificacion: 'Código de verificación',
        Et_lblCodigoVerificacionDescripcion: 'Por favor digite su código de verificación correspondiente.',
        Et_lblAdmisionProgramas: 'Programas',
        Et_lblAdmisionPlanes: 'Planes según programa',
        Et_lblDocumento: 'Documento',
        Et_lblAdjuntar: 'Adjuntar',
        Et_lblObtenerCodigo: 'Reenviar código de verificación',
        Et_lblAdjuntosPendientes: 'Hay requisitos de admisión pendientes de adjuntar a la documentación solicitada.',
        Et_lblEnviarAdmisionMsg: 'Hemos recibido su solicitud de admisión. El personal de la institución estará validando la documentación y recibirá un correo electrónico con los pasos a seguir. ¡Muchas gracias por elegir nuestra institución!',
        Et_lblOrigen: 'Origen',
        Et_InformacionAdicional:'Información Adicional',
        Et_lblcomenzar:'Comenzar'
    },
    InterfazDatosPersonales: {
        Et_TituloPrincipal: 'Información Personal',
        Et_tblCusTipoCIF: 'Tipo CIF',
        Et_tblCusTypeIdeFk: 'Tipo de identificación',
        Et_tblCusTypeIdeFkShort: 'Tipo de ID',
        Et_tblcusFullName: 'Nombre completo',
        Et_tblCusLastName1: 'Primer apellido',
        Et_tblCusLastName2: 'Segundo apellido',
        Et_tblFechaNacimiento: 'Fecha de nacimiento',
        Et_tblCusCivilStatusFkShort: 'Est. civil',
        Et_tblCusCivilStatusFk: 'Estado civil',
        Et_tblCusGenderFk: 'Género',
        Et_tblValidIdeMinimo: "El número de identificación tiene menos dígitos ({0}) de los permitidos para el tipo de identificación seleccionado ({1}).",
        Et_tblValidIdeMaximo: "El número de identificación tiene más dígitos ({0}) de los permitidos para el tipo de identificación seleccionado ({1}).",
        Et_tblValidIdeFormato: "El número de identificación no tiene el formato requerido para el tipo de identificación seleccionado. {0}",
        Et_tblIdeFormato: "Formato válido: {0}.",
    },
    InterfazClienteContactInfo: {
        Et_tblAddress: 'Direcciones',
        Et_tblAddressType: 'Tipo de dirección',
        Et_tblCountry: 'País',
        Et_tblProvince: 'Provincia',
        Et_tblCanton: 'Cantón',
        Et_tblDistrict: 'Distrito',
        Et_tblNeighborhood: 'Barrio',
        Et_tblExactAdress: 'Dirección exacta',
        Et_tblPostalCode: 'Código Postal',
        Et_tblContact: 'Teléfonos',
        Et_tblPhoneType: 'Tipo de teléfono',
        Et_tblPhone: 'Teléfono',
        Et_tblCountryCode: 'Código de país',
        Et_SelecAddTy: 'Seleccione el tipo de dirección',
        Et_SelecContactTyp: 'Seleccione el tipo de contacto',
        Et_SelecEmailTyp: 'Seleccione el tipo de correo',
        Et_tblEmailTittle: 'Correo electrónico',
        Et_tblEmailType: 'Tipo de correo',
        Et_tblEmail: 'Correo',
    },
    PlantillaCorreoToken: {
        Et_Hola: 'Hola ',
        Et_TextoSuCodigo: 'Su código de verificación es: ',
        Et_Gracias: 'Gracias por usar nuestro portal.',
        Et_Asunto: 'Código de verificación'
    },
    InterfazNacionalidad: {
        Et_tblCountrys: "Nacionalidades",
        Et_tblCIFs: "Tipos CIF",
        Et_SelecCIFs: "Tipo CIF",
        Et_tblCIF: "Tipo CIF",
        Et_SelecCountry: "País",
        Et_SelecTypeCountry: "Tipo nacionalidad",
        Et_tblCountry: "País",
        Et_tblTypeCountry: "Tipo nacionalidad",
        Et_tblNacionalidad: "Nacional",
        Et_tblRecidencia: "Residencia",
    },
};

const EtiquetasUnificadas = { ...EtiquetasGenerales_ES, ...EtiquetasModulo };

const Etiquetas_Es = {
    Idioma: "ES",
    Etiquetas: EtiquetasUnificadas
};

export default Etiquetas_Es;
